var _g, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCinema(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guide"
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,64h60c0.552,0,1-0.447,1-1V26c0-0.298-0.136-0.558-0.343-0.741l2.32-10.781c0.056-0.259,0.006-0.529-0.138-0.753 c-0.144-0.223-0.37-0.379-0.629-0.435l-12.267-2.64l-0.049-0.098l-0.123,0.061L8.922,1.607L8.895,1.553L8.827,1.587L4.704,0.699 C4.164,0.58,3.632,0.926,3.516,1.467L0.991,13.198c-0.056,0.259-0.006,0.529,0.138,0.753c0.144,0.223,0.37,0.379,0.629,0.435 L51.076,25H1c-0.552,0-1,0.447-1,1v37C0,63.553,0.448,64,1,64z M61.157,18.078l-1.783-3.567l2.438,0.525L61.157,18.078z  M56.868,13.972l3.616,7.233l-0.776,3.607l-1.887-0.406L52.09,12.944L56.868,13.972z M51.658,23.079l-5.731-11.462l3.657,0.787 l5.731,11.462L51.658,23.079z M21.834,6.432l3.657,0.787l5.731,11.462l-3.657-0.787L21.834,6.432z M25.059,17.354l-3.097-0.667 L16.231,5.226l3.097,0.667L25.059,17.354z M27.997,7.759l3.657,0.787l5.731,11.462l-3.657-0.787L27.997,7.759z M34.161,9.085 l3.097,0.667l5.731,11.462l-3.097-0.667L34.161,9.085z M39.764,10.291l3.657,0.787l5.731,11.462l-3.657-0.787L39.764,10.291z  M13.725,4.687l5.731,11.462l-3.657-0.787L10.068,3.9L13.725,4.687z M7.562,3.361l5.731,11.462l-3.657-0.787L4.897,4.557 l0.364-1.692L7.562,3.361z M4.224,7.684l2.906,5.812l-3.973-0.855L4.224,7.684z M2,27h58v35H2V27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31,32c-6.617,0-12,5.383-12,12s5.383,12,12,12s12-5.383,12-12S37.617,32,31,32z M31,54c-5.514,0-10-4.486-10-10 s4.486-10,10-10s10,4.486,10,10S36.514,54,31,54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.447,43.105l-10-5c-0.31-0.155-0.678-0.139-0.973,0.044C26.18,38.332,26,38.653,26,39v10c0,0.347,0.18,0.668,0.474,0.851 C26.635,49.95,26.817,50,27,50c0.153,0,0.306-0.035,0.447-0.105l10-5C37.786,44.725,38,44.379,38,44S37.786,43.275,37.447,43.105z  M28,47.382v-6.764L34.764,44L28,47.382z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 21,
    width: 2,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 2,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 21,
    width: 2,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 21,
    width: 2,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 2,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 21,
    width: 2,
    height: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 1,
    width: 2,
    height: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 5,
    width: 2,
    height: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 9,
    width: 2,
    height: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 1,
    width: 2,
    height: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 1,
    width: 2,
    height: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 1,
    width: 2,
    height: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 1,
    width: 2,
    height: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 1,
    width: 2,
    height: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 1,
    width: 2,
    height: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 1,
    width: 2,
    height: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 1,
    width: 2,
    height: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 1,
    width: 2,
    height: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinema);
export default __webpack_public_path__ + "static/media/cinema.06e4acc8.svg";
export { ForwardRef as ReactComponent };